import React from "react";
import { Truck, Pencil, Trash2, Phone, Landmark } from "lucide-react";
import { TRY } from "@/lib/api";
import { Card } from "@/components/Cards";

export const SUPPLIER_CATS = { GIDA: "Gıda", AMBALAJ: "Ambalaj", LOJISTIK: "Lojistik", GENEL: "Genel" };

export default function SupplierCard({ s, selected, onSelect, onEdit, onDelete }) {
  return (
    <Card data-testid={`supplier-card-${s.id}`} onClick={onSelect}
      className={`p-4 cursor-pointer transition-colors ${selected ? "border-primary ring-1 ring-primary/40" : "hover:border-border/80"}`}>
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3 min-w-0">
          <div className="h-10 w-10 rounded-lg bg-amber-400/10 text-amber-400 flex items-center justify-center shrink-0"><Truck className="h-5 w-5" /></div>
          <div className="min-w-0">
            <div className="font-heading font-semibold truncate">{s.name}</div>
            <div className="text-xs text-muted-foreground truncate">{SUPPLIER_CATS[s.category] || s.category} · {s.contact || "—"}</div>
          </div>
        </div>
        <div className="flex gap-1 shrink-0" onClick={(e) => e.stopPropagation()}>
          <button onClick={onEdit} data-testid={`supplier-edit-${s.id}`} className="h-8 w-8 rounded-lg hover:bg-accent flex items-center justify-center text-muted-foreground hover:text-foreground"><Pencil className="h-4 w-4" /></button>
          <button onClick={onDelete} data-testid={`supplier-delete-${s.id}`} className="h-8 w-8 rounded-lg hover:bg-destructive/10 flex items-center justify-center text-muted-foreground hover:text-destructive"><Trash2 className="h-4 w-4" /></button>
        </div>
      </div>
      <div className="mt-3 text-xs text-muted-foreground flex items-center gap-2 flex-wrap">
        <Phone className="h-3.5 w-3.5" /> {s.phone || "—"} <span className="mx-1">•</span> Vade: {s.payment_term_days} gün
      </div>
      <div className="mt-1.5 text-xs text-muted-foreground flex items-center gap-2"><Landmark className="h-3.5 w-3.5" /> {s.tax_office || "—"} / {s.tax_number || "—"}</div>
      <div className="mt-3 grid grid-cols-3 gap-2 text-center">
        <div className="rounded-lg bg-muted/50 py-2"><div className="text-[10px] uppercase tracking-wider text-muted-foreground">Alış</div><div className="font-mono font-semibold text-sm mt-0.5">{TRY(s.debit)}</div></div>
        <div className="rounded-lg bg-muted/50 py-2"><div className="text-[10px] uppercase tracking-wider text-muted-foreground">Ödenen</div><div className="font-mono font-semibold text-sm mt-0.5 text-emerald-400">{TRY(s.credit)}</div></div>
        <div className="rounded-lg bg-muted/50 py-2"><div className="text-[10px] uppercase tracking-wider text-muted-foreground">Borç</div><div className={`font-mono font-semibold text-sm mt-0.5 ${s.balance > 0 ? "text-amber-400" : ""}`} data-testid={`supplier-balance-${s.id}`}>{TRY(s.balance)}</div></div>
      </div>
    </Card>
  );
}
